import React from "react";
import { Outlet } from "react-router-dom";

const InventoryMaster: React.FC = () => {
  return <Outlet />;
};
export default InventoryMaster;
